import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export const PM_DEMO_ENTITY_ID = 'demo-entity';
export const PM_DEMO_BASE_PATH = '/purchase-manager-demo';
export const PM_LIVE_BASE_PATH = '/purchase-manager';

/**
 * Detects the unauthenticated Purchase Manager demo route and holds
 * compare-request metadata used by the demo HTTP interceptor.
 */
@Injectable({
    providedIn: 'root'
})
export class PmDemoModeService {
    readonly demoEntityId = PM_DEMO_ENTITY_ID;
    private compareItemByRequestId = new Map<string, string>();

    constructor(private router: Router) { }

    get isActive(): boolean {
        return this.isDemoUrl(this.router.url) || this.isDemoUrl(window.location?.pathname);
    }

    isDemoUrl(url: string): boolean {
        const path = (url || '').split('?')[0];
        return path.includes(PM_DEMO_BASE_PATH);
    }

    get basePath(): string {
        return this.isActive ? PM_DEMO_BASE_PATH : PM_LIVE_BASE_PATH;
    }

    registerCompareRequest(itemName: string): string {
        const requestId = `demo-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        this.compareItemByRequestId.set(requestId, itemName || '');
        return requestId;
    }

    getCompareItemName(requestId: string): string {
        return this.compareItemByRequestId.get(requestId) || '';
    }
}
